"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationOptionsApi = void 0;
var AuthenticationOptionsApi = (function () {
    function AuthenticationOptionsApi(native) {
        this._native = native;
    }
    Object.defineProperty(AuthenticationOptionsApi.prototype, "userName", {
        get: function () {
            return this._native.core.modelManager.richOptions.documentProtection.authenticationUserName;
        },
        set: function (value) {
            this._native.core.modelManager.richOptions.documentProtection.authenticationUserName = value;
            this._native.core.modelManager.modelManipulator.documentProtectionProperties.raiseProtectionPropertiesChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthenticationOptionsApi.prototype, "group", {
        get: function () {
            return this._native.core.modelManager.richOptions.documentProtection.authenticationGroup;
        },
        set: function (value) {
            this._native.core.modelManager.richOptions.documentProtection.authenticationGroup = value;
            this._native.core.modelManager.modelManipulator.documentProtectionProperties.raiseProtectionPropertiesChanged();
        },
        enumerable: false,
        configurable: true
    });
    return AuthenticationOptionsApi;
}());
exports.AuthenticationOptionsApi = AuthenticationOptionsApi;
